import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PlanTaskSchema } from './shapes';

/** Change the linked ClickUp task's status (the only external mutation). */
export const setPlanTaskStatus = defineEndpoint({
  method: 'PATCH',
  path: '/v1/release-plans/:planId/tasks/:taskId/status',
  params: z.object({ planId: z.string().uuid(), taskId: z.string().uuid() }),
  query: z.object({}),
  body: z.object({ status: z.string().trim().min(1).max(100) }),
  response: z.object({ data: PlanTaskSchema }),
});
